import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, getCurrentInstance } from 'vue'
import { getSecondBrandListApi } from '@/apis/merchant-admin'
import { BrandM } from '@/models/brand'


export default /*@__PURE__*/_defineComponent({
  __name: 'SelectMerchantSecondBrand',
  props: {
    classNames: {   // 类名
        type: Array,
        default: ['filter-item']
    },
    filterable: {   // 是否可筛选
        type: Boolean,
        default: true
    },
    clearable: {    // 是否可一键清除
        type: Boolean,
        default: true
    },
    multiple: {     // 是否可多选
        type: Boolean,
        default: false
    },
    ifBody: {     // 品牌类型：0-实物（默认），1-电子券，2-全部
        type: Number,
        default: 2
    },
    idShow: {     // id_show=1 会将对应的品牌ID与品牌名称连接进行返回 
        type: Number,
        default: 0
    },
    status: {    // 品牌上下架状态，默认全部
        type: Number,
        default: 2
    },
    placeholder: {    // 提示信息
        type: String,
        default: '请选择二级品牌'
    },
    disabledIds: { // 禁用项列表
        type: String,
        default: ''
    },
    collapseTags: { // 多选时是否将选中值按文字的形式展示
        type: Boolean,
        default: false
    },
    maxCollapseTags: { // 需要显示的 Tag 的最大数量。 只有当 collapse-tags 设置为 true 时才会生效
        type: Number,
        default: 1
    }
},
  emits: ['secondBrandChange'],
  setup(__props, { expose: __expose, emit: __emit }) {

const proxy = getCurrentInstance() as any
const emits = __emit
const props = __props

const brandProps = {
    value: 'id',
    label: 'name',
    disabled: 'disabled'
}
const selectedId = ref('')
const list = ref<BrandM[]>([])
const onGetList = async () => {
    const {code, data, msg} = await getSecondBrandListApi({
        is_page: 2
    }) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }

    const disabledIdList = props.disabledIds?.split(',').map(item => Number(item)) || []
    data.forEach((item:BrandM) => {
        item.disabled = disabledIdList.includes(item.id)
    })
    list.value = data
}
onGetList()

// 品牌变化，通过父组件
const onSelectedSecondBrandChange = () => {
    emits('secondBrandChange', selectedId.value)
}
// 清空数据
const clear = () => {
    selectedId.value = ''
}
__expose({
    clear
})

return (_ctx: any,_cache: any) => {
  const _component_el_select_v2 = _resolveComponent("el-select-v2")!

  return (_openBlock(), _createBlock(_component_el_select_v2, {
    class: _normalizeClass(__props.classNames),
    modelValue: selectedId.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedId).value = $event)),
    filterable: __props.filterable,
    clearable: __props.clearable,
    multiple: __props.multiple,
    placeholder: __props.placeholder,
    props: brandProps,
    options: list.value,
    collapseTags: __props.collapseTags,
    maxCollapseTags: __props.maxCollapseTags,
    onChange: onSelectedSecondBrandChange
  }, null, 8, ["class", "modelValue", "filterable", "clearable", "multiple", "placeholder", "options", "collapseTags", "maxCollapseTags"]))
}
}

})